(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .constant('memberAdminResolver', {
            member: getMember
        });

    getMember.$inject = ['Member', '$transition$', 'defaultMemberDetailPageSize', 'activeClubIdAccessor'];
    function getMember(Member, $transition$, defaultMemberDetailPageSize, activeClubIdAccessor) {
        var params = $transition$.params(),
            individualId = params.individualId,
            clubId = activeClubIdAccessor.clubId;

        return Member.getProfile({ id: individualId, clubId: clubId }, true).$promise;
    }
})();